(() => {
  'use strict';

  /* ================= CONFIG: edit these ================= */
  const CONFIG = {
    currency: 'USD',
    locale: 'en-US',
    // Per-unit compare-at ("was") price. Only set one you genuinely charged before; otherwise it's a
    // misleading discount under FTC and state pricing rules. null hides it.
    compareAt: null,
    // Shopify variant IDs: Products > TapReview > click a variant > the number at the end of the URL.
    // Supplier SKU mapping is in launch-kit.md.
    // price: fallback only. On load the page fetches live prices and availability from Shopify;
    // these show if that request fails.
    // stock: null hides the count. Only set a number if it matches real inventory.
    variants: {
      'black-ring':  { id: 52896303153432, price: 14.99, stock: null },   // Tap to review design (Shopify: style a black)
      'white-ring':  { id: 52896303251736, price: 14.99, stock: null },   // style a white
      'black-stars': { id: 52896303317272, price: 14.99, stock: null },   // Google stars design (style b black)
      'white-stars': { id: 52896303382808, price: 14.99, stock: null },   // style b white
      'tiktok':      { id: 52896303186200, price: 14.99, stock: null },
      'line':        { id: 52896303218968, price: 14.99, stock: null },
      'instagram':   { id: 52896303284504, price: 14.99, stock: null },   // Shopify: ins
      'facebook':    { id: 52896303350040, price: 14.99, stock: null },
    },
    // Bundle discounts: % off every stand once the cart has at least `min` stands (any mix of styles).
    // Must match the automatic discounts in Shopify > Discounts, which are what checkout actually charges.
    bundles: [{ min: 5, pct: 20 }, { min: 3, pct: 10 }],   // highest min first
    lowStockAt: 10,          // "Low stock" shows at or below this count (only when stock is set)
    maxPerStyle: 10,         // most stands of one style a cart can hold (the page and cart drawer enforce it)
    shipsTo: ['US', 'CA', 'GB', 'AU', 'NZ', 'MX', 'IL', 'AE'],   // country codes from Shopify > Settings > Shipping; elsewhere Shopify marks every style unavailable
    shopDomain: 'volticshop.myshopify.com',   // used when this page is hosted outside Shopify
    productHandle: 'tapreview-nfc-google-review-stand',   // live prices and availability load from this Shopify product (or a variant's own handle)
    // Confirm these with a test order to a US address.
    // Fastest and slowest business days from order to doorstep, by the visitor's country (Shopify.country).
    deliveryDays: { GB: [4, 7], AE: [5, 8], NZ: [5, 11], US: [6, 10], AU: [6, 10], MX: [6, 10], IL: [6, 10], CA: [8, 13] },
    deliveryDaysFallback: [6, 10],   // any other country, or when the page runs outside Shopify
    guaranteeDays: 14,
    reviews: { rating: null, count: null },   // your own customers' rating and review count; null hides the row
  };
  /* ====================================================== */

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const form = $('#buy');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const onShopify = Boolean(window.Shopify && window.Shopify.shop);
  const shopBase = onShopify ? '' : `https://${CONFIG.shopDomain}`;
  // Shopify knows the visitor's country only inside the store; elsewhere assume they can buy.
  const country = onShopify ? window.Shopify.country : null;
  const shipsHere = !country || CONFIG.shipsTo.includes(country);

  const STYLES = {
    'black-ring': 'Black · Tap to review',
    'white-ring': 'White · Tap to review',
    'black-stars': 'Black · Google stars',
    'white-stars': 'White · Google stars',
    'tiktok': 'TikTok',
    'line': 'LINE',
    'instagram': 'Instagram',
    'facebook': 'Facebook',
  };

  const currency = new Intl.NumberFormat(CONFIG.locale, { style: 'currency', currency: CONFIG.currency });
  const money = n => currency.format(n);
  const fill = (name, text) => $$(`[data-fill="${name}"]`).forEach(el => { el.textContent = text; });
  const noun = qty => (qty > 1 ? 'stands' : 'stand');
  const bundleFor = qty => CONFIG.bundles.find(b => qty >= b.min);
  // Shopify takes the % off each stand and rounds the discount down to the cent.
  const unitPrice = (variant, qty) => variant.price - Math.floor(variant.price * (bundleFor(qty)?.pct ?? 0) + 1e-9) / 100;

  /* ---------- Static values from CONFIG ---------- */
  fill('guarantee', CONFIG.guaranteeDays);
  const [minDays, maxDays] = CONFIG.deliveryDays[country] || CONFIG.deliveryDaysFallback;
  fill('delivery-days', maxDays);
  // "from" only when variant prices differ
  function fillLowestPrice() {
    const prices = Object.values(CONFIG.variants).filter(v => v.stock !== 0).map(v => v.price);
    if (!prices.length) return;
    fill('price-single', (new Set(prices).size > 1 ? 'from ' : '') + money(Math.min(...prices)));
  }
  fillLowestPrice();

  const dayFmt = new Intl.DateTimeFormat(CONFIG.locale, { month: 'short', day: 'numeric' });
  const inBusinessDays = n => {
    const d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  };
  fill('delivery', `${minDays}–${maxDays} business days · ${dayFmt.formatRange(inBusinessDays(minDays), inBusinessDays(maxDays))}`);

  const { rating, count } = CONFIG.reviews;
  if (rating && count) {
    const link = $('[data-reviews]');
    link.hidden = false;
    $('.fill', link).style.setProperty('--pct', `${(rating / 5) * 100}%`);
    const text = $('[data-fill="review-text"]', link);
    text.textContent = `${rating.toFixed(1)} · ${count} reviews`;
    link.setAttribute('aria-label', `Rated ${rating} out of 5 from ${count} reviews`);
  }

  /* ---------- Variant + quantity state ---------- */
  const qtyInputs = $$('input[name="quantity"]', form);

  function state() {
    const key = form.elements.style.value;
    const qty = Number(qtyInputs.find(r => r.checked).value);
    return { qty, key, variant: CONFIG.variants[key] };
  }

  function update() {
    // Never offer a pack size that tracked stock can't fill.
    const { stock } = state().variant;
    qtyInputs.forEach(r => { r.disabled = stock != null && Number(r.value) > stock; });
    const checked = qtyInputs.find(r => r.checked);
    const fallback = qtyInputs.filter(r => !r.disabled).pop();
    if (checked.disabled && fallback) fallback.checked = true;

    const s = state();
    const total = unitPrice(s.variant, s.qty) * s.qty;
    const label = STYLES[s.key];

    $$('[data-variant-img]').forEach(img => { img.src = variantPhoto(s.key, img.dataset.variantImg); });
    fill('style-name', label);

    fill('price', money(total));
    $$('.bundle').forEach(card => {
      const qty = Number($('input', card).value);
      const each = unitPrice(s.variant, qty);
      $('[data-b="price"]', card).textContent = money(each * qty);
      $('[data-b="each"]', card).textContent = `${money(each)} each`;
      const saving = each < s.variant.price;
      const was = $('[data-b="was"]', card);
      if (was) { was.textContent = money(s.variant.price * qty); was.parentElement.hidden = !saving; }
      const save = $('[data-b="save"]', card);
      if (save) { save.textContent = `Save ${bundleFor(qty)?.pct ?? 0}%`; save.hidden = !saving; }
    });
    const compare = (CONFIG.compareAt || s.variant.price) * s.qty;
    const showCompare = compare > total + 0.001;
    $$('[data-compare]').forEach(el => { el.hidden = !showCompare; });
    if (showCompare) {
      fill('compare', money(compare));
      fill('save-pct', `Save ${Math.round((1 - total / compare) * 100)}%`);
    }
    fill('summary', `${label} · ${s.qty} ${noun(s.qty)}`);

    form.elements.id.value = s.variant.id ?? '';
    const soldOut = s.variant.stock === 0;
    const unavailableLabel = shipsHere ? 'Sold out' : 'Not available in your country';
    $$('[data-atc]').forEach(btn => { btn.disabled = soldOut; });
    fill('atc-label', soldOut ? unavailableLabel : `Add to cart · ${money(total)}`);
    fill('atc-short', soldOut ? unavailableLabel : 'Add to cart');

    const ships = `arrives within ${maxDays} business days`;
    let level = 'ok';
    let text = `Ready to ship · ${ships}`;
    if (!shipsHere) { level = 'out'; text = "We don't ship to your country yet."; }
    else if (s.variant.stock === 0) { level = 'out'; text = `Sold out in ${label}. Try another option.`; }
    else if (s.variant.stock != null && s.variant.stock <= CONFIG.lowStockAt) { level = 'low'; text = `Low stock: ${s.variant.stock} left in ${label}`; }
    else if (s.variant.stock != null) text = `In stock · ${ships}`;
    $('[data-stock]').dataset.stock = level;
    fill('stock-text', text);
  }

  form.addEventListener('change', e => {
    if (e.target.name === 'style') goTo(variantSlide(state().key));
    update();
  });

  /* ---------- Cart: adding never leaves the page ----------
     Both backends return the same shape:
     { count, subtotal, savings, checkoutUrl, lines: [{ id, variantId, qty, total, was, image, title }] } */
  const drawer = $('#cart');
  const cartLink = $('[data-cart-link]');
  const cartCount = $('[data-cart-count]');
  const lineList = $('[data-cart-lines]', drawer);
  const msg = $('[data-cart-msg]', drawer);
  const checkout = $('[data-checkout]', drawer);
  const keyByVariant = new Map(Object.entries(CONFIG.variants).map(([key, v]) => [String(v.id), key]));
  let cart = null;

  function shaped(count, subtotal, checkoutUrl, lines) {
    return { count, subtotal, checkoutUrl, lines, savings: lines.reduce((sum, l) => sum + l.was - l.total, 0) };
  }

  async function request(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body && JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok || data.errors) throw new Error(data.description || data.errors?.[0]?.message || `HTTP ${res.status}`);
    return data;
  }

  // Inside the Shopify store: the store's own cart (Ajax Cart API), the same one /cart and checkout use.
  const ajaxCart = (() => {
    const shape = c => shaped(c.item_count, c.total_price / 100, '/checkout', c.items.map(i => ({
      id: i.key, variantId: String(i.variant_id), qty: i.quantity,
      total: i.final_line_price / 100, was: i.original_line_price / 100, image: i.image, title: i.variant_title,
    })));
    return {
      load: () => request('/cart.js').then(shape),
      add: (variantId, quantity) => request('/cart/add.js', { items: [{ id: variantId, quantity }] }).then(() => request('/cart.js')).then(shape),
      update: (lineId, quantity) => request('/cart/change.js', { id: lineId, quantity }).then(shape),
    };
  })();

  // Hosted outside Shopify: a Storefront API cart (no token needed), remembered in this browser.
  const storefrontCart = (() => {
    const KEY = 'tapreview-cart';
    const savedId = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
    const saveId = id => { try { id ? localStorage.setItem(KEY, id) : localStorage.removeItem(KEY); } catch {} };
    const FIELDS = `id checkoutUrl totalQuantity cost { subtotalAmount { amount } }
      lines(first: 50) { nodes { id quantity cost { subtotalAmount { amount } totalAmount { amount } }
        merchandise { ... on ProductVariant { id title image { url(transform: { maxWidth: 160 }) } } } } }`;
    let cartId = savedId();

    // A null cart means it expired or was checked out.
    const shape = c => {
      cartId = c?.id ?? null;
      saveId(cartId);
      return c && shaped(c.totalQuantity, Number(c.cost.subtotalAmount.amount), c.checkoutUrl, c.lines.nodes.map(l => ({
        id: l.id, variantId: l.merchandise.id.split('/').pop(), qty: l.quantity,
        total: Number(l.cost.totalAmount.amount), was: Number(l.cost.subtotalAmount.amount), image: l.merchandise.image?.url, title: l.merchandise.title,
      })));
    };
    const graphql = (query, variables) => request(`${shopBase}/api/2025-07/graphql.json`, { query, variables }).then(r => r.data);
    async function mutate(params, call, variables) {
      const data = await graphql(`mutation(${params}) { ${call} { cart { ${FIELDS} } userErrors { message } } }`, variables);
      const { cart: next, userErrors } = data[call.slice(0, call.indexOf('('))];
      if (userErrors.length) throw new Error(userErrors[0].message);
      return shape(next);
    }
    return {
      load: () => (cartId ? graphql(`query($id: ID!) { cart(id: $id) { ${FIELDS} } }`, { id: cartId }).then(d => shape(d.cart)) : Promise.resolve(null)),
      async add(variantId, quantity) {
        const lines = [{ merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity }];
        const added = cartId
          ? await mutate('$cartId: ID!, $lines: [CartLineInput!]!', 'cartLinesAdd(cartId: $cartId, lines: $lines)', { cartId, lines }).catch(() => null)
          : null;
        return added || mutate('$lines: [CartLineInput!]', 'cartCreate(input: { lines: $lines })', { lines });
      },
      update: (lineId, quantity) => mutate('$cartId: ID!, $lines: [CartLineUpdateInput!]!', 'cartLinesUpdate(cartId: $cartId, lines: $lines)',
        { cartId, lines: [{ id: lineId, quantity }] }),
    };
  })();

  const backend = onShopify ? ajaxCart : storefrontCart;

  function setCart(next) {
    cart = next && next.count ? next : null;
    const n = cart?.count ?? 0;
    cartCount.textContent = n;
    cartCount.hidden = !n;
    cartLink.setAttribute('aria-label', n ? `Cart, ${n} ${n > 1 ? 'items' : 'item'}` : 'Cart, empty');
    renderCart();
  }

  function lineLabel(line) {
    const key = keyByVariant.get(line.variantId);
    return { key, name: key ? STYLES[key] : line.title };
  }

  function renderCart() {
    // Re-rendering replaces the buttons, so remember which one had focus and restore it.
    const focusKey = document.activeElement?.dataset?.focusKey;
    const lines = cart?.lines ?? [];
    const tpl = $('#cart-line');
    lineList.replaceChildren(...lines.map(line => {
      const li = tpl.content.firstElementChild.cloneNode(true);
      const { key, name } = lineLabel(line);
      $('img', li).src = key ? variantPhoto(key, 'small') : line.image ?? '';
      $('[data-l="title"]', li).textContent = `TapReview: ${name}`;
      $('[data-l="group"]', li).setAttribute('aria-label', `Quantity of ${name}`);
      $('[data-l="qty"]', li).textContent = line.qty;
      $('[data-l="price"]', li).textContent = money(line.total);
      $('[data-l="was"]', li).textContent = line.was > line.total ? money(line.was) : '';
      [['dec', line.qty - 1, `Remove one ${name}`], ['inc', line.qty + 1, `Add one more ${name}`], ['remove', 0, `Remove ${name} from cart`]]
        .forEach(([part, qty, labelText]) => {
          const btn = $(`[data-l="${part}"]`, li);
          btn.setAttribute('aria-label', labelText);
          btn.dataset.focusKey = `${line.variantId}:${part}`;   // Shopify changes a line's id when its discount changes
          btn.disabled = part === 'inc' && line.qty >= CONFIG.maxPerStyle;
          btn.addEventListener('click', () => changeQty(line, qty));
        });
      return li;
    }));

    const savings = cart?.savings ?? 0;
    $('[data-cart-empty]', drawer).hidden = lines.length > 0;
    $('[data-cart-savings]', drawer).hidden = savings < 0.005;
    fill('cart-savings', `−${money(savings)}`);
    fill('cart-subtotal', money(cart?.subtotal ?? 0));

    const qty = cart?.count ?? 0;
    const next = [...CONFIG.bundles].reverse().find(b => b.min > qty);
    const hint = $('[data-cart-hint]', drawer);
    hint.hidden = !qty || !next;
    if (next) hint.textContent = `Add ${next.min - qty} more ${noun(next.min - qty)} to save ${next.pct}% on every stand.`;

    checkout.href = cart?.checkoutUrl ?? '#';
    checkout.setAttribute('aria-disabled', String(!cart));

    if (focusKey) {
      const target = $(`[data-focus-key="${CSS.escape(focusKey)}"]`, drawer);
      (target || (cart ? checkout : $('.icon-btn', drawer))).focus();
    }
  }

  async function changeQty(line, quantity) {
    if (lineList.getAttribute('aria-busy') === 'true') return;
    lineList.setAttribute('aria-busy', 'true');
    msg.className = 'cart-msg';
    msg.textContent = '';
    try {
      setCart(await backend.update(line.id, Math.max(0, quantity)));
      if (quantity <= 0) msg.textContent = `Removed ${lineLabel(line).name}.`;
    } catch (err) {
      console.warn('Cart update failed', err);
      msg.className = 'cart-msg err';
      msg.textContent = "Couldn't update your cart. Please try again.";
    } finally {
      lineList.removeAttribute('aria-busy');
    }
  }

  function openCart() {
    if (!drawer.open) drawer.showModal();
  }

  let adding = false;
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const s = state();
    if (!s.variant.id || adding) return;
    const permalink = `${shopBase}/cart/${s.variant.id}:${s.qty}`;
    if (e.submitter?.value === '/checkout') { location.href = permalink; return; }   // "Buy it now": straight to checkout

    const inCart = (cart?.lines ?? []).filter(l => l.variantId === String(s.variant.id)).reduce((n, l) => n + l.qty, 0);
    if (inCart + s.qty > CONFIG.maxPerStyle) {
      const left = CONFIG.maxPerStyle - inCart;
      msg.className = 'cart-msg err';
      msg.textContent = left > 0
        ? `You can order up to ${CONFIG.maxPerStyle} of each style. You can add ${left} more ${STYLES[s.key]}.`
        : `You can order up to ${CONFIG.maxPerStyle} of each style, and you already have ${CONFIG.maxPerStyle} ${STYLES[s.key]} in your cart.`;
      openCart();
      return;
    }

    adding = true;
    const buttons = $$('[data-atc]').filter(b => b.type === 'submit' && b.value !== '/checkout');
    buttons.forEach(b => b.setAttribute('aria-busy', 'true'));
    fill('atc-label', 'Adding…');
    fill('atc-short', 'Adding…');
    try {
      setCart(await backend.add(s.variant.id, s.qty));
      msg.className = 'cart-msg';
      msg.textContent = `Added ${s.qty} × ${STYLES[s.key]} to your cart.`;
      openCart();
    } catch (err) {
      console.warn('Add to cart failed; using the Shopify cart page instead.', err);
      location.href = `${permalink}?storefront=true`;
    } finally {
      adding = false;
      buttons.forEach(b => b.removeAttribute('aria-busy'));
      update();
    }
  });

  cartLink.addEventListener('click', e => {
    e.preventDefault();
    msg.textContent = '';
    openCart();
  });
  drawer.addEventListener('click', e => { if (e.target === drawer) drawer.close(); });
  checkout.addEventListener('click', e => { if (!cart) e.preventDefault(); });

  if (!onShopify) $$('a[href^="/"]').forEach(a => { a.href = `${shopBase}${a.getAttribute('href')}`; });

  backend.load().then(setCart).catch(err => console.warn('Could not load the cart.', err));

  /* ---------- Gallery ---------- */
  const track = $('.g-track');
  const slides = $$('.g-slide', track);
  const thumbs = $$('.g-thumb');
  const strip = $('.g-thumbs');
  let active = 0;

  // Each variant has its own slide (data-variant); its photo is reused in the sticky bar, final CTA and cart.
  const variantSlide = key => Math.max(0, slides.findIndex(slide => slide.dataset.variant === key));
  const variantPhoto = (key, size) => $('img', (size === 'large' ? slides : thumbs)[variantSlide(key)]).getAttribute('src');

  function goTo(i) {
    const index = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: index * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function markActive(i) {
    active = i;
    thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
    fill('g-index', i + 1);
    const t = thumbs[i];
    strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== active) markActive(i);
    });
  }, { passive: true });
  thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
  $('.g-prev').addEventListener('click', () => goTo(active - 1));
  $('.g-next').addEventListener('click', () => goTo(active + 1));

  /* ---------- Sticky add-to-cart: shown once the hero is scrolled past, hidden at the final CTA/footer ---------- */
  const sticky = $('#sticky');
  const hero = $('.hero');
  const blockers = new Set();
  let pastHero = false;
  const stickyObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.target === hero) pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
      else if (e.isIntersecting) blockers.add(e.target);
      else blockers.delete(e.target);
    });
    sticky.classList.toggle('show', pastHero && blockers.size === 0);
  });
  [hero, $('#final'), $('.site-footer')].forEach(el => stickyObserver.observe(el));

  /* ---------- Scroll reveal ---------- */
  const reveals = $$('.reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(el => el.classList.add('in'));
  } else {
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(el => io.observe(el));
  }

  update();

  /* ---------- Live product data from Shopify: prices and availability ---------- */
  // Each variant loads from its own product (its handle, or CONFIG.productHandle).
  const byHandle = new Map();
  Object.values(CONFIG.variants).forEach(v => {
    const handle = v.handle || CONFIG.productHandle;
    byHandle.set(handle, [...(byHandle.get(handle) || []), v]);
  });
  byHandle.forEach((variants, handle) => {
    fetch(`${shopBase}/products/${handle}.js`, { headers: { Accept: 'application/json' } })
      .then(r => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then(product => {
        const live = new Map(product.variants.map(v => [v.id, v]));
        variants.forEach(v => {
          const shopifyVariant = live.get(v.id);
          if (!shopifyVariant) { v.stock = 0; return; }   // deleted in Shopify: show as sold out
          v.price = shopifyVariant.price / 100;            // Shopify sends cents
          if (!shopifyVariant.available) v.stock = 0;
        });
        fillLowestPrice();
        update();
      })
      .catch(err => console.warn(`Could not load live data for ${handle} from Shopify; showing saved prices.`, err));
  });
})();
